import React from 'react'
import './AttendTeamAdmin.css'
import { Radio } from 'antd'
import { useState } from 'react';
import HRAdmin from './HRAdmin';
import AttendanceTacker from './AttendanceTaker';
function AttendTeamAdmin() {
    const [size, setSize] = useState("hr");
 
    const onChange = (e) => {
        setSize(e.target.value);
      };
  return (
    <div className='p-2'>
        {size === 'hr' ? <p className='text-sm text-[#00305F] font-sbold'>Hear, you can setup your HR attendance team and thair access to various feature. This section only be visible to the people who have been given BO access to it. </p> : ""}
        {size === 'staff' ? <p className='text-sm text-[#00305F] font-sbold'>Hear, you can setup your  attendance team and thair access to various feature. This section only be visible to the people who have been given BO access to it. </p> : ""}
        {size === 'nonstream' ? <p className='text-sm text-[#00305F] font-sbold'>HR Admin, HR Executive can select the people from the employee list, and enable STREAM access for them hear.</p> : ""}
        {size === 'dept' ? <p className='text-sm text-[#00305F] font-sbold'>HR Admin, HR Executive can select the department heads hear.Dept heads approve leavs, finalize attendance, fines, can take attendance, add contractors, manage shift (for their deppt).assign others as attendance takers as well</p> : ""}
        {size === 'Atten' ? <p className='text-sm text-[#00305F] font-sbold'>HR Admin, HR Executive can select the department heads hear.Dept heads approve leavs, finalize attendance, fines, can take attendance, add contractors, manage shift (for their deppt).assign others as attendance takers as well</p> : ""}
        
       
        <div className='flex !mt-2 !mb-4'>
                <Radio.Group value={size} onChange={onChange} className='primary-tabs'>
                    <Radio.Button value="hr">HR Admin (BO Access)</Radio.Button>
                    <Radio.Button value="Atten">Attendance Takers</Radio.Button>
                </Radio.Group>
            </div>
           
            <div>
                {size === 'hr' ? <HRAdmin /> : size === 'Atten' ? <AttendanceTacker /> :""}
            </div>
    </div>
  )
}

export default AttendTeamAdmin